/*!
 * Copyright © 2019-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DeviceHealthIssueCategories, EPermissionStatus, EPlotType, IAssetBalloon, IUserPermissions } from '../../../core/models';
import { IDeviceHealth } from '../../../core/store/state';

@Component({
  selector: 'fm-asset-balloon',
  templateUrl: './asset-balloon.component.html',
  styleUrls: ['./asset-balloon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetBalloonComponent implements OnChanges {
  @Input()
  public balloon: IAssetBalloon;
  @Input()
  public permissions: IUserPermissions;
  @Input()
  public isStreetViewAvailable: boolean;
  @Input()
  public disableZoomTo: boolean;
  @Input()
  public vehicleHealthStatus: IDeviceHealth;

  @Output()
  public streetViewClicked = new EventEmitter<IAssetBalloon>();
  @Output()
  public zoomToClicked = new EventEmitter<IAssetBalloon>();
  @Output()
  public locationHistoryClicked = new EventEmitter<number>();
  @Output()
  public replayClicked = new EventEmitter<number>();

  @HostBinding('class.balloon-address-panel-ready')
  balloonAddressReady = false;
  EPlotType = EPlotType;

  public hasHealthStatusViewPermission: boolean;
  public showDeviceHealthDetails: boolean;
  public hasCameraIssuesViewPermission: boolean;

  public EPermissionStatus = EPermissionStatus;
  public readonly defaultAvatar = 'assets/images/balloons/avatar-placeholder-asset.svg';

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.balloon) {
      this._isballoonAddressReady();
      this.hasHealthStatusViewPermission = this._getPermissionForHealthStatus();
      this.showDeviceHealthDetails = this._doesDeviceHasIssue();
      this.hasCameraIssuesViewPermission = this._getPermissionForVideoExperience();
    }
  }

  private _doesDeviceHasIssue() {
    if (this.vehicleHealthStatus && this.vehicleHealthStatus.vehicleId === this.balloon?.id?.toString()) {
      return DeviceHealthIssueCategories.findIndex(x => x === this.vehicleHealthStatus.healthStatus.toUpperCase()) > -1;
    }
    return false;
  }

  private _getPermissionForHealthStatus(): boolean {
    return this.permissions?.manageVehicles === EPermissionStatus.Full;
  }

  private _getPermissionForVideoExperience(): boolean {
    return this.permissions?.videoExperience === EPermissionStatus.Full;
  }

  public onZoomTo(): void {
    this.zoomToClicked.emit(this.balloon);
  }

  public onStreetView(): void {
    this.streetViewClicked.emit(this.balloon);
  }

  public onLocationHistory(): void {
    this.locationHistoryClicked.emit(this.balloon.id);
  }

  public onReplay(): void {
    this.replayClicked.emit(this.balloon.id);
  }

  private _isballoonAddressReady() {
    this.balloonAddressReady = this.balloon.address && this.balloon.address.length > 0;
  }
}
